/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateParentProfileDto } from '../../models/update-parent-profile-dto';

export interface ParentProfileControllerUpdateMyDataWithUser$Params {
      body: UpdateParentProfileDto
}

export function parentProfileControllerUpdateMyDataWithUser(http: HttpClient, rootUrl: string, params: ParentProfileControllerUpdateMyDataWithUser$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, parentProfileControllerUpdateMyDataWithUser.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

parentProfileControllerUpdateMyDataWithUser.PATH = '/api/parent-profile/with-user';
